<template>
    <div
        class="hts-step-by-step"
        :class="CClass">
        <div
            v-for="(step, index) in steps"
            :key="index"
            class="container">
            <div class="felt">
                <div class="in-step">
                    <slot
                        name="feltInStep"
                        :step="step" />
                </div>
                <div class="in-line">
                    <slot
                        name="feltInLine"
                        :step="step" />
                </div>
            </div>
            <div class="step-item">
                <div class="step-circle" />
                <div
                    v-if="index !== steps.length - 1"
                    class="step-line"
                    :class="{
                        'step-line-waiting': step.type === 'waiting',
                        'step-line-default': step.type !== 'waiting'
                    }" />
                <div
                    v-if="index === steps.length - 1 && addEndPoint"
                    class="step-line"
                    :class="{
                        'step-line-waiting': step.type === 'waiting',
                        'step-line-default': step.type !== 'waiting'
                    }" />
            </div>
            <div class="right">
                <div class="in-step">
                    <slot
                        name="rightInStep"
                        :step="step" />
                </div>
                <div class="in-line">
                    <slot
                        name="rightInLine"
                        :step="step" />
                </div>
                <div class="right">
                    <slot
                        name="right"
                        :step="{ ...step, index: index }" />
                </div>
            </div>
        </div>

        <div
            v-if="addEndPoint"
            class="container">
            <div class="felt" />
            <div class="flex items-center flex-col">
                <div class="step-circle-end" />
            </div>
            <div class="right" />
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  steps: {
    type: Array,
    required: true
  },
  direction: {
    type: String,
    default: 'vertical'
  },
  addEndPoint: {
    type: Boolean,
    default: false
  }
})

const { steps, direction } = toRefs(props)

const CClass = computed(() => {
  let classData = ''

  const directions: String[] = ['horizontal', 'vertical']

  if (directions.includes(direction.value)) {
    classData += direction.value
  }

  return classData
})
</script>
